import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import Select, { SingleValue } from 'react-select';
import { T } from '../../../Translations';
import { StringOption } from '../../Options/Types';
import { timezones } from './Functions';

export interface Props {
  timezone: string;
  disabled: boolean;
  setTimezone: (timezone: string) => void;
}

const handleChange = (setTimezone: Props['setTimezone']) => (e: SingleValue<StringOption>) => {
  const calculatedValue = fromNullable(e)
    .map(({ value }) => value)
    .getOrElseValue('');
  return setTimezone(calculatedValue);
};

function TimeZone({ setTimezone, timezone, disabled }: Props) {
  return (
    <div className="flex flex-col">
      <label htmlFor="timezone" className="font-semibold text-sm">
        <T kind="Timezone" />
      </label>
      <Select
        value={{ value: timezone, label: timezone }}
        onChange={handleChange(setTimezone)}
        styles={{
          control: (baseStyles, { isDisabled }) => ({
            ...baseStyles,
            padding: '.13rem',
            backgroundColor: isDisabled ? '#F2F2F3' : 'white',
            borderColor: '#BEC0C5',
          }),
          menuPortal: (base) => ({ ...base, zIndex: 50 }),
        }}
        options={timezones.map((t) => ({ value: t, label: t }))}
        name="timezone"
        id="timezone"
        inputId="timezone"
        menuPortalTarget={document.body}
        className="rounded border-gray-300 w-60"
        isDisabled={disabled}
      />
    </div>
  );
}

export default observer(TimeZone);
